export const CategoryBadgeColor: Record<string, 'primary' | 'secondary' | 'tertiary'> = {
  Avisos: 'secondary',
  Eventos: 'primary',
  Obras: 'secondary',
  Assembleia: 'primary',
  Comunidade: 'tertiary',
};
